// extracted by mini-css-extract-plugin
export var actionText = "_qw-4";
export var container = "_qw-0";
export var leftSection = "_qw-1";
export var rightSection = "_qw-2";
export var settingsButton = "_qw-6";
export var settingsIcon = "_qw-7";
export var shortcut = "_qw-5";
export var shortcutGroup = "_qw-3";